// Time-based 0..1 amounts for the overlay transitions (lens in/out, strategic cross-fade, fog fold).

/** Move `value` toward `target` at 1/`seconds` per second, never past it. */
export function approach(value: number, target: number, dt: number, seconds: number): number {
  const step = dt / seconds;
  if (value < target) {
    return Math.min(target, value + step);
  }
  return Math.max(target, value - step);
}

/** Smoothstep of t clamped to 0..1: the ease used for every overlay transition. */
export function ease(t: number): number {
  const c = Math.min(1, Math.max(0, t));
  return c * c * (3 - 2 * c);
}
